import { GridCellProps } from "@progress/kendo-react-grid";
import React, { FC } from "react";
import { useState } from "react";
import { COLOR } from "utils/constant";

export const TextEditCell: FC<
	GridCellProps & {
		field?: any;
		checked?: boolean;
		disabled?: boolean;
		readonly?: boolean;
	}
> = ({ field = "", ...props }) => {
	const dataItem = props.dataItem;

	const [value, setValue] = useState();
	const [isFocused, setIsFocused] = useState(false);

	const onBlur = (e: any) => {
		if (!props.onChange) {
			//console.log("no props onBlur");
			return;
		}

		props.onChange({
			dataItem,
			dataIndex: props.dataIndex,
			syntheticEvent: e,
			field,
			value,
		});
	};

	const handleChange = (event: any) => {
		setValue(event.target.value);
		dataItem[field as string] = event.target.value;
	};

	return (
		<td
			style={{ ...props.style, textAlign: "center" }}
			className={props.className}
		>
			<input
				value={dataItem[field as string] || ""}
				type="text"
				disabled={props.disabled}
				readOnly={props.readonly}
				//onChange={(e) => onCheck && onCheck(e.target.value, dataItem)}
				style={{
					width: "98%",
					outline: "none",
					border: isFocused
						? `1px solid ${COLOR.Green}`
						: `1px solid ${COLOR.Green}`,
				}}
				onFocus={() => setIsFocused(true)}
				onChange={handleChange}
				onBlur={(e) => {
					setIsFocused(false);
					onBlur(e);
				}}
			/>
		</td>
	);
};
